import React, { useState, useContext, useEffect } from "react"
import { FirebaseContext } from "../Firebase"
import { WingsModal, WingsTextInput, WingsTextArea } from "@wingspans-ui"
import { FormattedMessage, useIntl } from "react-intl"
import "./portfolio-editor-modal-styles.css"

/**
 * Modal used to edit a user's introduction section.
 */
const IntroductionEditModal = ({show, savedQuote, savedIntroduction, savedCity, savedState, onClose}) => {
  const {
    firebase,
    notifier,
    setWalkThroughStepValues,
  } = useContext(FirebaseContext)
  const { formatMessage } = useIntl()
  const [quote, setQuote] = useState("")
  const [introduction, setIntroduction] = useState("")
  const [city, setCity] = useState("")
  const [state, setState] = useState("")

  const resetFormValues = () => {
    setQuote(savedQuote || "")
    setIntroduction(savedIntroduction || "")
    setCity(savedCity || "")
    setState(savedState || "")
  }

  useEffect(() => {
    if (show) {
      resetFormValues()
    }
  }, [show, savedQuote, savedIntroduction, savedCity, savedState])

  const handleSave = async () => {
    try {
      await firebase.updateProfile({ 
        data: {
          profileQuote: quote,
          introduction: introduction,
          city: city,
          state: state,
          // remove any deprecated introduction values
          aboutMe: "",
          myStrengths: "",
          myWeaknesses: "",
        } 
      })
      
      await firebase.saveWalkthroughStep("buildPortfolio", true)
      onClose()
      notifier.handlePersonalInfoSetting()
      firebase.getWalkthroughSteps().then(res => setWalkThroughStepValues(res))
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <WingsModal
      className="portfolio-editor-modal" 
      isOpen={show}
      onClose={onClose}
      size="lg"
      title={<FormattedMessage id="portfolio-introduction-edit-modal-title" defaultMessage="Edit Introduction Section" />}
      titleLevel={5}
      primaryActionLabel={<FormattedMessage id="resume-experience-editor-modal-save" defaultMessage="Save"/>}
      onPrimaryAction={handleSave}
    >
      <WingsModal.Body>
        <WingsTextArea
          label={formatMessage({ id: "portfolio-personal-info-form-quote", defaultMessage: "Quote" })}
          helpText={formatMessage({
            id: "portfolio-personal-info-form-default-quote",
            defaultMessage: "Choose a quote that captures the essence of who you are. It can be your own or one that's well known.",
          })}
          id="quote"
          maxLength={1000}
          rows={2}
          fullWidth
          value={quote}
          onChange={(event) => setQuote(event.target.value)}
        />

        <WingsTextArea
          label={formatMessage({ id: "portfolio-personal-info-form-introduction", defaultMessage: "Introduction" })}
          helpText={formatMessage({
            id: "portfolio-personal-info-form-default-about-me",
            defaultMessage: "What makes you unique? Talk about your biggest wins, your most compelling experiences, and what inspires you to do what you do. Show, not tell.",
          })}
          id="introduction"
          maxLength={2000}
          rows={3}
          fullWidth
          value={introduction}
          onChange={(event) => setIntroduction(event.target.value)}
        />

        <WingsTextInput
          label={formatMessage({ id: "portfolio-personal-info-form-city", defaultMessage: "City" })}
          id="city"
          maxLength={50}
          fullWidth
          value={city}
          onChange={(event) => setCity(event.target.value)}
        />

        <WingsTextInput
          label={formatMessage({ id: "portfolio-personal-info-form-state", defaultMessage: "State" })}
          id="state"
          maxLength={15}
          fullWidth
          value={state}
          onChange={(event) => setState(event.target.value)}
        />
      </WingsModal.Body>
    </WingsModal>
  )
}

export default IntroductionEditModal
